module.exports = __webpack_public_path__ + "img/icon-decoration12.72d97b12.png";